<script>
export default {};
</script>

<template>
  <div class="flex justify-around content-center configuration__content">
    <div>
      <p class="configuration__title">Procesar órdenes con "Flete dinámico" automáticamente</p>
      <p class="configuration__subtitle">
        Todas las ordenes de Mercado Libre con modalidad flete dinámico se
        procesarán automáticamente.
      </p>
    </div>
    <div class="flex items-center">
      <label class="switch">
        <input type="checkbox" />
        <span class="slider round"></span>
      </label>
    </div>
  </div>
</template>